//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import {mapGetters} from 'vuex'

import Vue from 'vue'
import { VBModal } from 'bootstrap-vue'
Vue.directive('b-modal', VBModal)

export default {

    name: "RequestCard",

    data() {
        return {
            isToggle: false,
        }
    },

    watch: {

        cartCount: function (newVal, oldVal) {
            if(oldVal === 0 && newVal > 0) {
                this.isToggle = true
            } else if (newVal <= 0) {
                this.isToggle = false
            }
        },

    },

    computed: {

        ...mapGetters('search', ['requestCart']),

        cartCount() {
            return this.requestCart.length;
        },
    },

    methods: {
        removeItemFrom(index) {
            this.$store.dispatch("search/removeItem", index);
        },

        ClearAllRequests() {
            this.$store.dispatch("search/ClearAllRequests")
            this.isToggle = false
        }
    },
}
